<template>
  <LoadingData v-if="loadData" />
  <div v-else>
    <div v-if="course.type === '2' && isAdmin === 1">
      <DetailsCourseWithEdit :courseId="courseId" />
      <RolesCourse :courseId="courseId" />
      <ModulesCourse :courseId="courseId" />
      <QuestionsCourse :courseId="courseId" />
    </div>
    <DetailsCourseWithoutEdit v-else :course="course" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DetailsCourseWithEdit from '@/components/courses/courses/DetailsCourseWithEdit.vue'
import RolesCourse from '@/components/courses/courses/RolesCourse.vue'
import ModulesCourse from '@/components/courses/modules/ModulesCourse.vue'
import QuestionsCourse from '@/components/courses/questions/QuestionsCourse.vue'
import DetailsCourseWithoutEdit from '@/components/courses/courses/DetailsCourseWithoutEdit.vue'
import PATHS from '@/router/routesMap'

export default {
  name: 'CourseDetails',

  components: {
    LoadingData,
    DetailsCourseWithEdit,
    RolesCourse,
    ModulesCourse,
    QuestionsCourse,
    DetailsCourseWithoutEdit,
  },

  data() {
    return {
      courseId: this.$route.params.courseId,
      loadData: true,
      course: {},
    }
  },

  computed: {
    isAdmin() {
      return this.$store.getters.user.isAdmin
    },
  },

  methods: {
    async getCourse() {
      try {
        this.course = await this.$store.dispatch('getCourse', this.courseId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },
  },

  mounted() {
    this.getCourse()
  },
}
</script>
